/* eslint-disable no-console -- 全站唯一允許碰 console 的地方 */

type LogPayload = Record<string, unknown> | undefined;

const isDev = import.meta.env.DEV;

function serialize(payload: LogPayload): unknown[] {
  return payload ? [payload] : [];
}

export function logInfo(message: string, payload?: LogPayload): void {
  if (!isDev) return;
  console.info(`[info] ${message}`, ...serialize(payload));
}

export function logWarn(message: string, payload?: LogPayload): void {
  console.warn(`[warn] ${message}`, ...serialize(payload));
}

export function logError(message: string, error?: unknown, payload?: LogPayload): void {
  console.error(`[error] ${message}`, error, ...serialize(payload));
}
